// extracted by mini-css-extract-plugin
export var orderDetails = "_r4-2";
export var orderImage = "_r4-1";
export var orderMeta = "_r4-3";
export var orderSummary = "_r4-0";
export var rightArrow = "_r4-4";